export default {
  setIsShoppingListLoading(state, payload) {
    state.isShoppingListLoading = payload;
  },
  setDefaultList(state, payload) {
    state.defaultShoppingList = payload;
  },
  setShoppingLists(state, payload) {
    state.shoppingLists = payload;
  },
  updateItemInList(state, payload) {
    const index = state.shoppingLists.findIndex(item => item.id === payload.id);
    if (index !== -1) {
      state.shoppingLists.splice(index, 1, payload);
    } else {
      console.error(`Item with id ${payload.id} not found.`);
    }
  },
  setShoppingListsTypes(state, payload) {
    state.shoppingListsTypes = payload;
  },
  setShoppingListCycles(state, payload) {
    state.shoppingListCycles = payload;
  },
};
